module.exports = __webpack_public_path__ + "img/jk_tab.fa061dc6.png";